import { rubIcon } from "../../../../shared/assets/svg/rubIcon";
import { Stack } from "../../../../shared/ui/Stack/Stack";
import { Text } from "../../../../shared/ui/Text/Text";
import { ImplantPriceData } from "../lib/data";
import styles from './ImplantPrice.module.scss';

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';


gsap.registerPlugin(useGSAP);
gsap.registerPlugin(ScrollTrigger); 

const ImplantPrice = () => {

    useGSAP(() => {
        gsap.to(".implantPrice", { "--opacity": 1, 
                                    "--x": "0px",
                                    y:-10,  
                                    duration: 1,
                                    scrollTrigger: {
                                        trigger: ".implantPrice"
        }});
    }, [])

    return (  
        <div className={styles.container}>
            <Stack     
                    justifyContent = 'justifyCenter'                    
            >
                <Text type="h2" size='l' className={`implantPrice ${styles.title}`}>
                    СТОИМОСТЬ УСЛУГ
                </Text>    
            </Stack>
            {ImplantPriceData.map(element => 
                <div            
                    className={styles.priceContent}
                    key={element.id}
                >

                    <Text  size='m' className={styles.text}>
                        {element.service}
                    </Text>  
                    <Text  size='m' className={styles.price}>
                        {element.price} {rubIcon()}
                    </Text>    
                </div>
        )}
        </div>
    );
}

export default ImplantPrice;